export function buildTireSize(width, profile, diameter, frontRear = "R") {
  return `${width}/${profile}${frontRear}${diameter}`;
}
